import { MatchListTop } from "@/features/match/components/MatchListTop";
import { MatchTable } from "@/features/match/components/MatchTable";
import { useSanitizedPageParam } from "@/hooks/useSanitizedPageParam";
import { Stack } from "@mui/material";
import { FC } from "react";
import { EMatchContractStatus } from "@/types/enum";

type TTrialCancelledListPageProps = {};

const contractStatuses = [EMatchContractStatus.TRIAL_CANCELLED];

export const TrialCancelledListPage: FC<TTrialCancelledListPageProps> = () => {
  useSanitizedPageParam();

  return (
    <Stack gap={2}>
      <MatchListTop contractStatuses={contractStatuses} />
      <MatchTable contractStatuses={contractStatuses} />
    </Stack>
  );
};
